// src/components/ProtectedRoute.tsx
import { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from './Router';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4452C]"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={requireAdmin ? "/admin/login" : "/connecter"} />;
  }

  // Check if admin access is required but user is not an admin
  if (requireAdmin && user.type !== 'admin') {
    // FIX: Instead of redirecting to login (which sees user is logged in and redirects back),
    // we show an Unauthorized message or specific error page.
    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-4">
            <h1 className="text-2xl font-bold text-gray-900">Accès Refusé</h1>
            <p className="text-gray-600 mt-2">Vous n'avez pas les droits d'administrateur.</p>
            <a href="/" className="mt-4 text-[#D4452C] hover:underline">Retour à l'accueil</a>
        </div>
    );
  }

  return <>{children}</>;
}